import React from "react";
import clientData from "../../assets/data/client-data.json";
import { motion } from "framer-motion";
import ClientLogoCard from "./ClientLogoCard";

function ClientsList() {
  return (
    <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
      {clientData.map((client, idx) => (
        <motion.li
          key={client.image}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.35, delay: (idx % 5) * 0.05 }}
        >
          <ClientLogoCard client={client} />
        </motion.li>
      ))}
    </ul>
  );
}

export default ClientsList;
